<template>
  <div data-testid="suggestions-view">
    <NavBar>
      <template #left>
        <ButtonIcon
          :colors="closeButtonColors"
          :tabindex="0"
          role="button"
          label="Voltar"
          icon="EA0030"
          @click="goBack"
        />
      </template>
    </NavBar>
    <main class="investment-suggestions">
      <section class="investment-suggestions__partner-section">
        <PartnerCard
          :partner-name="partnerName"
          class="investment-suggestions__partner-section-card"
        />
      </section>
      <SuggestionsSection
        class="investment-suggestions__suggestions-section"
        :suggestions="suggestions"
        @suggestion-click="emitSuggestionClick"
      />
    </main>
  </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import {
  NavBar,
  ButtonIconFoundation as ButtonIcon
} from '@warrenbrasil/nebraska-web';
import { PartnerCard } from './components/PartnerCard';
import { SuggestionsSection } from './components/SuggestionsSection';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IGetInvestmentSuggestionsResponse } from '@/modules/wealth/services/investment-suggestions';

@Component({
  components: {
    ButtonIcon,
    NavBar,
    PartnerCard,
    SuggestionsSection
  }
})
export default class SuggestionView extends Vue {
  @Prop({ type: Object, required: true })
  private investmentSuggestions!: IGetInvestmentSuggestionsResponse;

  @Emit('suggestion-click')
  emitSuggestionClick() {}

  get closeButtonColors() {
    return {
      background: NebraskaColors.elementSecondary,
      content: NebraskaColors.elementPrimary,
      alphas: {
        default: 0,
        hover: 0.08,
        active: 0.08
      }
    };
  }

  get partnerName() {
    return this.investmentSuggestions.partner?.name || '';
  }

  get suggestions() {
    return this.investmentSuggestions.suggestions.data;
  }

  goBack() {
    this.$router.back();
  }
}
</script>
<style lang="less" scoped>
@navbar-height: 65px;

.investment-suggestions {
  display: flex;
  &__partner-section {
    width: 32%;

    &-card {
      margin: @size-spacing-x1000 @size-spacing-x1100;
    }
  }

  &__suggestions-section {
    width: 60%;
    min-height: calc(100vh - @navbar-height);
    border-left: @size-border-x400 solid @divider-primary;
    padding: @size-spacing-x1000 @size-spacing-x1100;
  }
}
</style>
